import { Component, OnInit, Input, HostBinding } from '@angular/core';
import { AccountConfigService } from '../../../services/account-config/account-config.service';
import { CheckableSettings } from '@progress/kendo-angular-treeview';
import { of } from 'rxjs';
import { FormationService } from '../../../services/formation/formation.service';
import { ActivatedRoute } from '@angular/router';
import { DocumentService } from '../../../services/document/document.service';
import { MUser, MAmzone } from '@argalis-apps/models';
import { AuthService } from './../../../../auth/services/auth/auth.service';
import { ApprenantService } from '../../../services/apprenant/apprenant.service';
import { downloadIcon, SVGIcon } from '@progress/kendo-svg-icons';

@Component({
  selector: 'ags-session-document',
  templateUrl: './session-document.component.html',
  styleUrls: ['./session-document.component.scss'],
})
export class SessionDocumentComponent implements OnInit {
  @HostBinding('class') themeFlag = 'account-theme';
  public loading: any;
  public id;
  public table = '';
  public docname: any;
  public selected = 0;
  public listeDoc = {};
  public infodoc: any;
  public checkedKeys: any[] = [];
  public isLoadingDoc = true;
  public isLoadingVrac = true;
  public errorServer = false;
  public enableCheck = true;
  public checkChildren = true;
  public checkParents = true;
  public checkOnClick = false;
  public checkMode: any = 'multiple';
  public selectedItems: any[] = [];
  public listMenu: any = [
    { name: 'Session', content: 'session', disabled: false },
    { name: 'Produit', content: 'produit', disabled: false },
    { name: 'Apprenant', content: 'apprenant', disabled: false },
    { name: 'Intervenant', content: 'intervenant', disabled: false },
    { name: 'Client', content: 'client', disabled: false },
    { name: 'Organisme', content: 'of', disabled: false },
  ];
  public svgDownload: SVGIcon = downloadIcon;
  public idSession: any;
  @Input('idSession')
  set _idSession(value: string) {
    if (value) {
      this.idSession = value;
    }
  }
  public userConnected: MUser.CUser;
  public get checkableSettings(): CheckableSettings {
    return {
      checkChildren: this.checkChildren,
      checkParents: this.checkParents,
      enabled: this.enableCheck,
      mode: this.checkMode,
      checkOnClick: this.checkOnClick,
    };
  }
  public dataDoc: any[] = [];
  public dataDocVrac: any[] = [];
  public listeApprenant = [];

  public children = (dataItem: any) => of(dataItem.items);
  public hasChildren = (dataItem: any): boolean => !!dataItem.items && dataItem.items.length > 0;

  constructor(
    private accountConfigService: AccountConfigService,
    private formationService: FormationService,
    private documentService: DocumentService,
    private apprenantService: ApprenantService,
    private route: ActivatedRoute,
    private authService: AuthService,
  ) {
    this.userConnected = this.authService.userConnected || null;
  }

  ngOnInit() {
    this.themeFlag = `${this.themeFlag || ''} ${this.accountConfigService.themingClassName}`;
    this.getDocumentInformation(this.idSession);
    this.getDocumentVracInformation(this.idSession);
  }
  getDocumentInformation(idSession) {
    this.isLoadingDoc = true;
    let idSessionClient = false;
    const listIdSessionClient = [];
    this.dataDoc = [];
    this.apprenantService.getApprenantBySession(idSession).subscribe((app) => {
      if (app.length) {
        for (const apprenant of app) {
          const newIdSessionClient = apprenant ? apprenant.id_session_client_beneficiaire : false;
          if (listIdSessionClient.includes(newIdSessionClient)) continue;
          idSessionClient = apprenant ? apprenant.id_session_client_beneficiaire : false;
          listIdSessionClient.push(idSessionClient);
          this.formationService
            .getDocment(
              idSession,
              this.listMenu[this.selected].content,
              idSessionClient,
              this.userConnected.userInfo.id,
            )
            .subscribe(
              (result) => {
                this.applyDoc(result);
                this.formationService
                  .getDocment(
                    idSession,
                    this.listMenu[this.selected].content,
                    idSessionClient,
                    this.userConnected.userInfo.id,
                    true,
                  )
                  .subscribe(
                    (resultVrac) => {
                      this.isLoadingDoc = false;
                      this.applyDoc(resultVrac, true);
                    },
                    (err) => {
                      this.isLoadingDoc = false;
                    },
                  );
              },
              (err) => {
                this.isLoadingDoc = false;
              },
            );
        }
      } else {
        const idSessionClient = false;
        this.formationService
          .getDocment(idSession, this.listMenu[this.selected].content, idSessionClient, this.userConnected.userInfo.id)
          .subscribe(
            (result) => {
              this.dataDoc = result;
              this.formationService
                .getDocment(idSession, this.listMenu[this.selected].content, idSessionClient, this.userConnected.userInfo.id, true)
                .subscribe(
                  (resultVrac) => {
                    this.isLoadingDoc = false;
                    for (const doc of resultVrac) {
                      if (!doc.libelle_doc) doc.libelle_doc = doc.libelle;
                    }
                    this.dataDoc.concat(resultVrac);
                  },
                  (err) => {
                    this.isLoadingDoc = false;
                  }
                );
            },
            (err) => {
              this.isLoadingDoc = false;
            },
          );
      }
    });
  }

  applyDoc(result, bVrac = false) {
    const toDelete = [];
    for (const document of result) {
      const docIndex = this.dataDoc.findIndex((e) => e.id === document.id);
      if (docIndex > -1) {
        toDelete.push(document.id);
      }
    }
    for (const id of toDelete) {
      const index = result.findIndex((e) => e.id === id);
      if (index > -1) {
        result.splice(index, 1);
      }
    }
    for (const doc of result) {
      if (!doc.libelle_doc) doc.libelle_doc = doc.libelle;
    }
    this.dataDoc = this.dataDoc.concat(result);
  }

  getDocumentVracInformation(idSession) {
    this.isLoadingVrac = true;
    this.formationService.getDocmentVrac(idSession, 'session').subscribe(
      (result) => {
        this.isLoadingVrac = false;
        this.dataDocVrac = result;
      },
      (err) => {
        this.isLoadingVrac = false;
      },
    );
  }

  uploadInfo(amazoneResponse: MAmzone.IAmazoneUploadReponse) {
    this.errorServer = false;
    if (amazoneResponse) {
      const tableLinked = 'session';
      this.documentService.insertDocument(tableLinked, this.idSession, amazoneResponse).subscribe(
        () => {
          this.getDocumentVracInformation(this.idSession);
        },
        () => {
          this.errorServer = true;
        },
      );
    }
  }

  onTabSelect(tab) {
    this.selectedItems = [];
    this.selected = tab.index;
    this.getDocumentInformation(this.idSession);
  }

  // Télécharge les documents présents dansselectedItems
  // Si plusieurs documents => télécharge un zip
  downloadDoc() {
    if (this.selectedItems && this.selectedItems.length) {
      if (this.selectedItems.length === 1) {
        window.open(this.selectedItems[0].url);
      } else {
        this.isLoadingDoc = true;
        this.formationService.getDocumentsZip(this.selectedItems).subscribe((response) => {
          const b64toBlob = require('b64-to-blob');
          const file = b64toBlob(response.resp, 'application/octet-stream');
          const url = window.URL.createObjectURL(file);
          // to do : check si il y a une meilleur méthode pour afficher le nom du doc
          const anchor = document.createElement('a');
          anchor.download = 'Téléchargement.zip';
          anchor.href = url;
          this.isLoadingDoc = false;
          anchor.click();
          // window.open(url);
        });
      }
    }
  }

  onCheckItem(item) {
    item._selected = !item._selected;

    // setChildren

    if (item.type === 'parent') {
      this.setChildren(item, item._selected);
    }
    // si le doc n'est pas un parent,
    // on le place dans un tableau d'items
    // pour matcher avec les params de setChildren
    else {
      const tempItem = { items: [item] };
      this.setChildren(tempItem, item._selected);
    }

    // setParents

    // Si id_regroup est null alors il n'a pas de parent
    if (item.id_regroup !== null) {
      this.setParent(this.dataDoc, item.id_regroup);
    }
  }

  // ATTENTION : cette fonction fonctionne pour un arbre de profondeur max 3
  // Cherche le node qui correspond à idParent
  // Puis coche les nodes parents ayant tout leurs enfants séléctionnés
  // Décoche les nodes parents dont au moins un des enfants est décoché
  setParent(tree, idParent) {
    let parent = null;
    for (let i = 0; i < tree.length; i++) {
      // si vrai on a trouvé le parent
      if (tree[i].id === idParent) {
        parent = tree[i];
        // si tout les enfants du parents sont cochés
        if (parent.items.every((child) => child._selected)) {
          // on coche le parent
          parent._selected = true;
        } else {
          // sinon on le décoche
          parent._selected = false;
        }
      }
      // si le node est lui même un parent on va chercher dans le node
      else if (tree[i].type === 'parent' && tree[i].items.length) {
        const nodeArray = tree[i].items;
        for (let j = 0; j < nodeArray.length; j++) {
          if (nodeArray[j].id === idParent) {
            parent = nodeArray[j];
            const grandParent = tree[i];
            // si tout les enfants du parents sont cochés
            if (parent.items.every((child) => child._selected)) {
              // on coche le parent
              parent._selected = true;

              if (grandParent.items.every((child) => child._selected)) {
                // on coche le parent
                grandParent._selected = true;
              } else {
                // sinon on le décoche
                grandParent._selected = false;
              }
            }
            // si au moins un des enfants n'est pas coché
            // on décoche tout les parents au dessus de lui
            else {
              parent._selected = false;
              grandParent._selected = false;
            }
          }
        }
      }
    }

    return null;
  }

  // Coche ou décoche les items enfants du parents séléctionné
  // on les ajoute ou les retire du tableau des items à télécharger
  // item est le node de l'arbre que l'on a coché
  // isChecked conserve l'action de base : cocher ou décocher, même dans la récursivité, il ne bouge jamais
  setChildren(item, isChecked) {
    item.items.map((itemChild) => {
      //on attribue la valeur isChecked à tout les enfants
      itemChild._selected = isChecked;

      if (itemChild.type === 'parent') {
        // si l'enfant est lui même un parent on gére ses propres enfants avec la même fonction
        this.setChildren(itemChild, isChecked);
      }
      // l'enfant n'est pas un parent => c'est un doc téléchargeable
      else if (isChecked && !this.selectedItems.some((elem) => elem.id === itemChild.id)) {
        // si on a coché son parent et que le doc n'est pas dans la liste des docs à télécharger on l'ajoute
        this.pushInSelectedItem(itemChild);
      } else if (!isChecked && this.selectedItems.some((elem) => elem.id === itemChild.id)) {
        // si on à décoché son parent et que le doc est dans la liste des docs à télécharger on le retire
        const index = this.selectedItems.indexOf(itemChild);
        this.selectedItems.splice(index, 1);
      }
    });
  }

  // place l'objet dans la list des items à télécharger
  pushInSelectedItem(item) {
    item = this.makeUniqueLibelle(item);
    this.selectedItems.push(item);
  }

  // Concat le libelle et le doc template, utile notamment pour les doc apprenants
  // sinon certains docs ont le mème nom et la fonction de zip n'en considere qu'un des 2
  makeUniqueLibelle(item) {
    item.libelle = item.libelle.concat('_', item.code_doc_template).replace(' ', '_');
    return item;
  }
}
